module.exports = __webpack_public_path__ + "img/downtown-country.860a3e9d.png";